import { ConfigProvider, Button, Form, Input, InputNumber, message, Modal, Select } from "antd";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import container from "@/lib/di/container";
import { ElectronicContractRepo } from "@/core/repos/tables/electronic-contract.repo";
import React from "react";
import { MODAL_THEME } from "@/core/themes/modal.theme";
import { SendOtpModel } from "@/core/models/electronic-contract.model";

const electronicContractRepo = container.get(ElectronicContractRepo);

interface SendOtpModalProps {
    isModalOpen: boolean,
    setIsModalOpen: Dispatch<SetStateAction<boolean>>,
    contractId: string,
    waterUserCode: string,
}

const INPUT_WIDTH = 450;

export const SendOtpModal: React.FC<SendOtpModalProps> = ({isModalOpen, setIsModalOpen, contractId, waterUserCode}) => {
    const [form] = Form.useForm<SendOtpModel>();
    const [loading, setLoading] = useState<boolean>(false);
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        if (isModalOpen) {
            form.setFieldsValue({
                electronicContractId: contractId,
                otpType: 1, // Default OTP type
                deviceOTP: ""
            });
        }
    }, [isModalOpen, contractId, form]);

    const handleSend = async () => {
        try {
            setLoading(true);
            const formData = await form.validateFields();
            const result = await electronicContractRepo.sendOtp({
                electronicContractId: contractId,
                otpType: formData.otpType,
                deviceOTP: formData.deviceOTP
            });
            
            if (result) {
                messageApi.success({
                    content: "Gửi OTP thành công"
                });
                setIsModalOpen(false);
            } else {
                messageApi.error({
                    content: "Gửi OTP thất bại"
                });
            }
        } catch (error) {
            console.log(error);
            messageApi.error({
                content: "Lỗi khi gửi OTP"
            });
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <ConfigProvider theme={MODAL_THEME}>
            {contextHolder}
            <Modal 
                open={isModalOpen} 
                onCancel={handleCancel} 
                width={600} 
                centered
                styles={{
                    mask: {
                        backdropFilter: 'blur(2px)',
                        backgroundColor: 'var(--primary-mask)'
                    }
                }}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>
                        Hủy
                    </Button>,
                    <Button key="send" type="primary" loading={loading} onClick={handleSend}>
                        Gửi OTP
                    </Button>,
                ]}
            >
                <div className="flex flex-row w-full items-center justify-start select-none mb-4">
                    <p className="ml-2 text-2xl font-bold text-primary">GỬI OTP</p>
                </div>
                <div className="flex flex-row justify-center mt-6">
                    <Form<SendOtpModel>
                        name="sendOtp"
                        className="flex flex-col items-end"
                        form={form}
                        layout="vertical"
                    >
                        <div className="grid grid-cols-1 gap-x-4 items-end">
                            <Form.Item<SendOtpModel>
                                label="Mã khách hàng"
                            >
                                <Input 
                                    value={waterUserCode}
                                    disabled
                                    style={{width: INPUT_WIDTH}}
                                ></Input>
                            </Form.Item>
                            <Form.Item<SendOtpModel>
                                label="Loại OTP"
                                name="otpType"
                                rules={[{ required: true, message: 'Vui lòng chọn loại OTP!' }]}
                                initialValue={1}
                            >
                                <Select placeholder="Chọn loại OTP" style={{width: INPUT_WIDTH}}>
                                    <Select.Option value={1}>SMS</Select.Option>
                                    <Select.Option value={2}>Email</Select.Option>
                                </Select>
                            </Form.Item>
                            <Form.Item<SendOtpModel>
                                label="Email/Số điện thoại"
                                name="deviceOTP"
                                rules={[
                                    { required: true, message: 'Vui lòng nhập email hoặc số điện thoại!' },
                                    { type: 'email', message: 'Vui lòng nhập đúng định dạng email!' }
                                ]}
                                help="Nhập email hoặc số điện thoại để nhận OTP"
                            >
                                <Input 
                                    placeholder="Nhập email hoặc số điện thoại" 
                                    style={{width: INPUT_WIDTH}}
                                ></Input>
                            </Form.Item>
                        </div>
                    </Form>
                </div>
            </Modal>
        </ConfigProvider>
    );
};
